import { render } from "./showStatistics.vue?vue&type=template&id=009cb433"
import script from "./showStatistics.vue?vue&type=script&lang=js"
export * from "./showStatistics.vue?vue&type=script&lang=js"

import "./showStatistics.vue?vue&type=style&index=0&id=009cb433&lang=less"
script.render = render

export default script